export default {
  language: {
    title: 'Skills',
    tech: [
      {
        img: process.env.PUBLIC_URL + '/assets/python.png',
        alt: 'Python',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/go.png',
        alt: 'Go',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/js.png',
        alt: 'JavaScript',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/c++.png',
        alt: 'C++',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/c.png',
        alt: 'C',
      },
    ],
  },

  techs: {
    title: 'Skills',
    tech: [
      {
        img: process.env.PUBLIC_URL + '/assets/django.png',
        alt: 'Django',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/odoo.png',
        alt: 'Odoo',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/drf.png',
        alt: 'Django REST Framework',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/celery.png',
        alt: 'Celery',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/docker.png',
        alt: 'Docker',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/psql.png',
        alt: 'PostgreSQL',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/mysql.png',
        alt: 'MySQL',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/react.png',
        alt: 'React.js',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/tcss.png',
        alt: 'Tailwind CSS',
      },
    ],
  },

  achievements: {
    categories: ['Academic', 'HackerRank', 'LinkedIn Learning', 'Brain Station 23', 'Company Training', 'Badges'],
    items: [
      // Dean's List — AIUB
      { id: 1,  category: 'Academic',          type: 'certificate', title: "Dean's List Honor", subtitle: 'Fall 2018-2019',    meta: 'GPA 3.79 • AIUB',                              file: 'Deans Awards/IMG_3956.jpg' },
      { id: 2,  category: 'Academic',          type: 'certificate', title: "Dean's List Honor", subtitle: 'Spring 2019-2020',  meta: 'GPA 3.85 • AIUB',                              file: 'Deans Awards/IMG_3955.jpg' },
      { id: 3,  category: 'Academic',          type: 'certificate', title: "Dean's List Honor", subtitle: 'Fall 2019-2020',    meta: 'GPA 3.80 • AIUB',                              file: 'Deans Awards/IMG_3951.jpg' },
      { id: 4,  category: 'Academic',          type: 'certificate', title: "Dean's List Honor", subtitle: 'Spring 2020-2021',  meta: 'GPA 3.90 • AIUB',                              file: 'Deans Awards/IMG_3965.jpg' },
      { id: 5,  category: 'Academic',          type: 'certificate', title: "Dean's List Honor", subtitle: 'Fall 2020-2021',    meta: 'GPA 3.85 • AIUB',                              file: 'Deans Awards/IMG_3959.jpg' },
      // HackerRank Certificates
      { id: 6,  category: 'HackerRank',        type: 'certificate', title: 'Python',            subtitle: 'Basic',             meta: 'HackerRank',  file: 'HackerRank/Python (Basic) Certificate.png' },
      { id: 7,  category: 'HackerRank',        type: 'certificate', title: 'Problem Solving',   subtitle: 'Basic',             meta: 'HackerRank',  file: 'HackerRank/Problem Solving (Basic) Certificate.png' },
      { id: 8,  category: 'HackerRank',        type: 'certificate', title: 'Problem Solving',   subtitle: 'Intermediate',      meta: 'HackerRank',  file: 'HackerRank/Problem Solving (Intermediate) Certificate.png' },
      { id: 9,  category: 'HackerRank',        type: 'certificate', title: 'REST API',           subtitle: 'Intermediate',      meta: 'HackerRank',  file: 'HackerRank/Rest API (Intermediate) Certificate.png' },
      // LinkedIn Learning
      { id: 10, category: 'LinkedIn Learning', type: 'certificate', title: 'Learning Django',         subtitle: 'Oct 2024',  meta: 'LinkedIn Learning',  file: 'LinkedIn Learning/CertificateOfCompletion_Learning Django.jpg' },
      { id: 11, category: 'LinkedIn Learning', type: 'certificate', title: 'Go Essentials',           subtitle: 'Oct 2024',  meta: 'LinkedIn Learning',  file: 'LinkedIn Learning/CertificateOfCompletion_Go Essentials Concurrency Connectivity and HighPerformance Apps.jpg' },
      { id: 12, category: 'LinkedIn Learning', type: 'certificate', title: 'Learning Go',             subtitle: 'Nov 2024',  meta: 'LinkedIn Learning',  file: 'LinkedIn Learning/CertificateOfCompletion_Learning Go.jpg' },
      { id: 13, category: 'LinkedIn Learning', type: 'certificate', title: 'Advanced Go Programming', subtitle: 'Nov 2024',  meta: 'LinkedIn Learning',  file: 'LinkedIn Learning/CertificateOfCompletion_Advanced Go Programming Data Structures Code Architecture and Testing.jpg' },
      // Brain Station 23
      { id: 14, category: 'Brain Station 23', type: 'certificate', title: 'Gen AI E1: Fundamentals',             subtitle: 'Nov 2024', meta: 'Brain Station 23', file: 'Brain Station 23/Gen AI E1 Fundamentals - Unlocking the Future.png' },
      { id: 15, category: 'Company Training', type: 'certificate', title: 'Anti-Corruption & Anti-Bribery',      subtitle: 'Brain Station 23', meta: 'Brain Station 23', file: 'Brain Station 23/Anti-Corruption and Anti-Bribery Policy.png' },
      { id: 16, category: 'Company Training', type: 'certificate', title: 'Cyber Security & Physical Protection',subtitle: 'Brain Station 23', meta: 'Brain Station 23', file: 'Brain Station 23/Cyber Security and Physical Protection.png' },
      { id: 17, category: 'Company Training', type: 'certificate', title: 'Digital Assets Security & Privacy',   subtitle: 'Brain Station 23', meta: 'Brain Station 23', file: 'Brain Station 23/Digital Assets Security and Privacy.png' },
      { id: 18, category: 'Company Training', type: 'certificate', title: 'Occupational Safety',                 subtitle: 'Fire & Earthquake', meta: 'Brain Station 23', file: 'Brain Station 23/Occupational Safety for Fire and Earthquake.png' },
      { id: 21, category: 'Company Training', type: 'certificate', title: 'CMMI Foundations',                    subtitle: 'Brain Station 23', meta: 'Brain Station 23', file: 'Brain Station 23/CMMI_Foundations.jpg' },
      // Badges
      { id: 19, category: 'Badges', type: 'badge', title: '50 Days Badge 2025',  subtitle: 'LeetCode', meta: '', file: 'LeetCode/download (1).png' },
      { id: 20, category: 'Badges', type: 'badge', title: '100 Days Badge 2025', subtitle: 'LeetCode', meta: '', file: 'LeetCode/download.png' },
    ],
  },

  tools: {
    title: 'Skills',
    tech: [
      {
        img: process.env.PUBLIC_URL + '/assets/git.png',
        alt: 'Git',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/vs.png',
        alt: 'VS Code',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/Postman.png',
        alt: 'Postman',
      },
            {
        img: process.env.PUBLIC_URL + '/assets/aws.png',
        alt: 'AWS',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/azure.png',
        alt: 'Azure',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/odoosh.png',
        alt: 'Odoo.sh',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/heroku.png',
        alt: 'Heroku',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/trello.png',
        alt: 'Trello',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/jira.png',
        alt: 'Jira',
      },
    ],
  },

  aiTools: {
    title: 'Skills',
    tech: [
      {
        img: process.env.PUBLIC_URL + '/assets/chatgpt.png',
        alt: 'ChatGPT',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/copilot.png',
        alt: 'GitHub Copilot',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/claude.png',
        alt: 'Claude',
      },
      {
        img: process.env.PUBLIC_URL + '/assets/gemini.png',
        alt: 'Gemini',
      },
    ],
  },
};
